<div class="progress-overlay">
    <div class="spinner-box">
        <mat-spinner></mat-spinner>
    </div>
</div>
